// src/components/generic/Footer.tsx
import { useTenant } from "../TenantContext";
import React, { useMemo } from 'react';

interface FooterProps {
    isEditingFromSummary?: boolean;
    onSummaryClick?: () => void;
}

interface FooterLinkItem {
    key: string;
    value: string;
}

export const Footer: React.FC<FooterProps> = ({ isEditingFromSummary = false, onSummaryClick }) => {
    const { tenantConfig } = useTenant();
    const imageUrl = tenantConfig?.authority?.authorityBranding?.logoUrl;
    const footerLinksString = tenantConfig?.authority?.authorityBranding?.footerlink;

    // Parse footer links with proper error handling and memoization
    const footerLinks = useMemo(() => {
        if (!footerLinksString) return [];

        try {
            const parsed: FooterLinkItem[] = JSON.parse(footerLinksString);
            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            console.error('Failed to parse footer links:', error);
            return [];
        }
    }, [footerLinksString]);




    return (
        <div className="w-full">
            <footer
                className="w-full min-h-[80px] md:h-[80px] bg-[#3e3e3e] text-gray-200 py-4 md:py-0"
                style={{ padding: "0px 96px" }}
                role="contentinfo"
            >
                <div className="flex flex-col md:flex-row justify-between items-center md:pt-2.5 gap-4 md:gap-0">
                    <div className="text-xl font-bold text-white">
                        {imageUrl && (
                            <img
                                src={imageUrl}
                                alt="Footer Logo"
                                className="h-12 md:h-16 w-auto"
                            />
                        )}
                    </div>

                    <nav aria-label="Footer navigation" className="flex items-center">
                        <ul className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6 text-center md:text-left">
                            {footerLinks.map((link, index) => (
                                <li key={`${link.key}-${index}`}>
                                    {link.value ? (
                                        <a
                                            href={link.value}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="hover:text-white text-sm md:text-base py-2 px-3 inline-block transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#3e3e3e] rounded"
                                            style={{ textDecoration: 'none' }}
                                            aria-label={`${link.key} (opens in new window)`}
                                        >
                                            {link.key}
                                        </a>
                                    ) : (
                                        <span
                                            className="text-sm md:text-base py-2 px-3 inline-block"
                                        >
                                            {link.key}
                                        </span>
                                    )}
                                </li>
                            ))}


                        </ul>
                    </nav>
                </div>
            </footer>
        </div>
    );
};